// extracted by mini-css-extract-plugin
export default {"wrapper":"NavButton_wrapper__BCPYx"};